import { AuthService } from "services/AuthService";
import { EmployeeService } from "services/EmployeeService";


const authService = new AuthService();
const employeeService = new EmployeeService();

const getUsers = async (setLoading: React.Dispatch<React.SetStateAction<boolean>>, setRows: React.Dispatch<React.SetStateAction<UserTableRow[]>>) => {
    try {
        setLoading(true);

        // const { data } = await instance_auth.get('/v1/user');
        const response = await authService.user.getUsers();
        const users = response?.map(user => ({
                id: user.user_id,
                username: user.username,
                profile_name: user.profile.name,
                profile_id: user.profile.profile_id,
                owner_user: user.owner_user,
                type: user.type,
                enable: { 'start':user.start_dtm , 'end':user.end_dtm },

            }));
        return setRows(users);
    } catch (error: any) {
        console.error('Error fetching users:', error.message);
    } finally {
        setLoading(false);
    }
}

const getUserById = async (setLoading: React.Dispatch<React.SetStateAction<boolean>>, id: number) => {
    try {
        setLoading(true);
        const response = await authService.user.getUser(id);
        return response;
    } catch (error: any) {
        console.error('Error fetching user:', error.message);
    } finally {
        setLoading(false);
    }
}

const addUser = async (setLoading: any, user: User) => {
    try {
        setLoading(true);
        return await authService.user.createUser({
            profile_id: user.profile_id,
            username: user.username,
            password: user.password,
            email: user.email || '',
        });
    } catch (error: any) {
        console.error('Error adding user:', error.message);
    } finally {
        setLoading(false);
    }
}

const getProfiles = async (setLoading: React.Dispatch<React.SetStateAction<boolean>>) => {
    try {
        setLoading(true);
        return  await authService.profile.getProfiles();
    } catch (error: any) {
        console.error('Error fetching profiles:', error.message);
    } finally {
        setLoading(false);
    }
}

const editUser = async (setLoading: React.Dispatch<React.SetStateAction<boolean>>, user: User, id: number) => {

    console.log('user:', user);
    try {
        setLoading(true);
        const response = await authService.user.updateUser(id, user);
        return response
    } catch (error: any) {
        console.error('Error editing user:', error.message);
    } finally {
        setLoading(false);
    }
}

const deactivateUser = async (setLoading: React.Dispatch<React.SetStateAction<boolean>>, data: User) => {

    try {
        setLoading(true);
        const response = await authService.user.deactivateUser(data);
        return response;
    } catch (error: any) {
        console.error('Error changing password:', error.message);
    } finally {
        setLoading(false);
    }
}

const assignExtraPermissions = async (setLoading: any, data: any, id: number) => {

    try {
        setLoading(true);
        const response = await authService.user.assignExtraPermissions(id, data);
        return response;
    } catch (error: any) {
        throw error;
    } finally {
        setLoading(false);
    }
}

const getTags = async (setLoading: any) => {
    try {
        setLoading(true);
        const response = await employeeService.employee.getTags();
        return response;
    } catch (error: any) {
        console.error('Error fetching tags:', error.message);
    } finally {
        setLoading(false);
    }
}

const assignExtraTags = async (setLoading: any, data: any, id: number) => {
    try {
        setLoading(true);
        const response = await authService.user.assignExtraTags(id, data);
        return response;
    } catch (error: any) {
        console.error('Error assigning extra tags:', error.message);
    } finally {
        setLoading(false);
    }
}

const getPermissions = async (setLoading: any) => {
    try {
        setLoading(true);
        const response = await authService.permission.getPermissions();
        return response
    } catch (error: any) {
        console.error('Error fetching permissions:', error.message);
    } finally {
        setLoading(false);
    }
}

const createUserOpt = async (setLoading: React.Dispatch<React.SetStateAction<boolean>>): Promise<CreateUserOptResponse | undefined> => {
    try {
        setLoading(true);
        const response = await authService.user.createUserOpt();
        return response;
    } catch (error: any) {
        console.error('Error creating user OTP:', error.message);
        throw error;
    } finally {
        setLoading(false);
    }
}

const deleteUserOpt = async (setLoading: React.Dispatch<React.SetStateAction<boolean>>): Promise<void> => {
    try {
        setLoading(true);
        await authService.user.deleteUserOpt();
    } catch (error: any) {
        console.error('Error deleting user OTP:', error.message);
        throw error;
    } finally {
        setLoading(false);
    }
}


export {
    getUsers,
    getUserById,
    addUser,
    getProfiles,
    editUser,
    deactivateUser,
    assignExtraPermissions,
    getTags,
    getPermissions,
    assignExtraTags,
    createUserOpt,
    deleteUserOpt,
}